import { Injectable, computed, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private readonly _router = inject(Router);
  private readonly _activeCount = signal(0);

  readonly isLoading = computed(() => this._activeCount() > 0);

  constructor() {
    this._registerNavigationReset();
  }

  show(): void {
    this._activeCount.update((count) => count + 1);
  }

  hide(): void {
    this._activeCount.update((count) => Math.max(0, count - 1));
  }

  reset(): void {
    this._activeCount.set(0);
  }

  private _registerNavigationReset(): void {
    this._router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe(() => this.reset());
  }
}
